@if ((sitesLocal$ | async)?.length > 1) {
  <form [formGroup]="form">
    <ng-select
      id="siteId"
      [clearable]="false"
      [items]="sitesLocal$ | async"
      (change)="onValueChange()"
      bindLabel="name"
      bindValue="id"
      formControlName="siteId"
    >
    </ng-select>
  </form>
}
